<template>
    <views>
        <nav-bar
            title="联系我们"
            fixed
            @click-left="onClickLeft">
        </nav-bar>
        <views class="contact">
            <views class="contact-banner">
                <images :src="bannerImg"></images>
            </views>
            <views class="contact-content">
                <views class="contact-list">
                    <views class="contact-label">地址</views>
                    <views class="contact-value">{{ detail.address }}</views>
                </views>
                <views class="contact-list">
                    <views class="contact-label">公司总机</views>
                    <views class="contact-value">{{ detail.phone }}</views>
                </views>
                <views class="contact-list">
                    <views class="contact-label">销售热线</views>
                    <views class="contact-value">{{ detail.hotline }}</views>
                </views>
                <views class="contact-list">
                    <views class="contact-label">传真</views>
                    <views class="contact-value">{{ detail.fax }}</views>
                </views>
                <views class="contact-list">
                    <views class="contact-label">邮箱</views>
                    <views class="contact-value">{{ detail.email }}</views>
                </views>
            </views>
            <views class="contact-wx">
                <images :src="contactImg"></images>
            </views>
        </views>
    </views>
</template>

<script>
import NavBar from '@/components/navBar'
import tools from '@/mixins/tools'
import api from '@/utils/api'
export default {
    components: {
        NavBar
    },
    mixins: [tools],
    data() {
        return {
            detail: {},
            bannerList: [],
            contactImg: require('@/assets/images/contact_wx.png')
        }
    },
    computed: {
        bannerImg() {
            return this.bannerList[0] && this.bannerList[0].url
        }
    },
    created() {
        this.getContactInfo()
        this.getBanner()
    },
    mounted() {
        this.setBgColor()
    },
    destroyed() {
        this.resetBgColor()
    },
    methods: {
        onClickLeft() {
            this.back()
        },
        getContactInfo() {
            api.getContactInfo().then((res) => {
                if (res.data.info) {
                    this.detail = res.data.info
                }
            })
        },
        getBanner() {
            api.getBanner({ position_type: 4 }).then((res) => {
                if (res.data.list) {
                    this.bannerList = res.data.list
                }
            })
        }
    }
}
</script>

<style lang="scss" scoped>
@import './index.scss';
</style>
